import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import mainLogo from "assets/ez_pay_logo.svg";
import { TextButton } from "kubra-ux-forge";
import { Outlet, useOutletContext } from "react-router";
import { ISession } from "types/session";
import { useTranslation } from "react-i18next";
import {
  COMMON_NAMESPACE,
  MENU_NAMESPACE,
  PRIVACY_MODAL_NAMESPACE,
} from "constants/i18n-namespaces";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import Sheet from "react-modal-sheet";
import { getPayableSession } from "selectors/payableSession";
import {
  LinkBorder,
  StyledFooter,
  StyledLinks,
} from "./styled-components/styled-footer";
import { TermsModal } from "../terms-modal";
import { PrivacyModal } from "../privacy-modal";
import { HelpModal } from "../help-modal";
import AboutModal from "../about-modal/about-modal";
import { CustomSheet } from "../menu/styled-components";
import { customStyles } from "constants/customStyles";
import XButton from "assets/icons/x_button.svg";

export const PayableFooter = (props: { isMobile: boolean }) => {
  const session = useOutletContext<ISession>();
  const payableSession = useSelector(getPayableSession);
  const { t } = useTranslation();
  const [aboutModalDisplay, setAboutModalDisplay] = useState(false);
  const [helpModalDisplay, setHelpModalDisplay] = useState(false);
  const [privacyModalDisplay, setPrivacyModalDisplay] = useState(false);
  const [termsModalDisplay, setTermsModalDisplay] = useState(false);
  const location = useLocation();

  const setAboutModalIsOpenToTrue = () => {
    setAboutModalDisplay(true);
  };

  const setAboutModalIsOpenToFalse = () => {
    setAboutModalDisplay(false);
  };

  const setHelpModalIsOpenToTrue = () => {
    setHelpModalDisplay(true);
  };

  const setHelpModalIsOpenToFalse = () => {
    setHelpModalDisplay(false);
  };

  const setPrivacyModalIsOpenToTrue = () => {
    setPrivacyModalDisplay(true);
  };

  const setPrivacyModalIsOpenToFalse = () => {
    setPrivacyModalDisplay(false);
  };

  const setTermsModalIsOpenToTrue = () => {
    setTermsModalDisplay(true);
  };

  const setTermsModalIsOpenToFalse = () => {
    setTermsModalDisplay(false);
  };

  useEffect(() => {
    if (location.pathname.includes("terms")) {
      setTermsModalDisplay(true);
    } else if (location.pathname.includes("privacy")) {
      setPrivacyModalDisplay(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <StyledFooter data-cy="ez-pay-footer">
        <div className="ez-pay-menu-main">
          <span className="ez-pay-menu-logo-helper"></span>
          <img
            src={mainLogo}
            alt="KUBRA EZ-PAY"
            className="ez-pay-menu-logo"
            data-cy="menu-logo"
          />
        </div>
        <StyledLinks data-cy="links">
          <TextButton
            data-cy="navigate-help"
            hoverStyle="underline"
            onClick={() => setHelpModalIsOpenToTrue()}
            className="payable-footer-link-button"
          >
            {t("help", { ns: COMMON_NAMESPACE })}
          </TextButton>
          <LinkBorder />
          <TextButton
            data-cy="navigate-policy"
            hoverStyle="underline"
            onClick={() => setAboutModalIsOpenToTrue()}
            className="payable-footer-link-button"
          >
            {t("about-ez-pay", { ns: MENU_NAMESPACE })}+
          </TextButton>
          <LinkBorder />
          <TextButton
            data-cy="navigate-policy"
            hoverStyle="underline"
            onClick={() => setPrivacyModalIsOpenToTrue()}
            className="payable-footer-link-button"
          >
            {t("privacy-policy", { ns: MENU_NAMESPACE })}
          </TextButton>
          <LinkBorder />
          <TextButton
            data-cy="navigate-terms"
            hoverStyle="underline"
            onClick={() => setTermsModalIsOpenToTrue()}
            className="payable-footer-link-button"
          >
            {t("terms-of-use", { ns: MENU_NAMESPACE })}
          </TextButton>
        </StyledLinks>
        {/* about ez-pay modal and sheet */}
        {props.isMobile && (
          // @ts-ignore
          <CustomSheet
            isOpen={aboutModalDisplay}
            onClose={() => setAboutModalIsOpenToFalse}
            detent="content-height"
            disableDrag={true}
          >
            <CustomSheet.Container>
              <CustomSheet.Header>
                <div>
                  <button
                    className="modal-close-mobile"
                    data-cy="modal-close-x-about"
                    onClick={setAboutModalIsOpenToFalse}
                  >
                    <img
                      src={XButton}
                      alt="close modal window"
                      className="modal-close-x"
                    />
                  </button>
                </div>
              </CustomSheet.Header>
              <CustomSheet.Content>
                <AboutModal closeCallBack={setAboutModalIsOpenToFalse} />
              </CustomSheet.Content>
            </CustomSheet.Container>
            {/* @ts-ignore */}
            <Sheet.Backdrop onClick={setAboutModalIsOpenToFalse} />
          </CustomSheet>
        )}
        {!props.isMobile && (
          // @ts-ignore
          <Modal
            isOpen={aboutModalDisplay}
            ariaHideApp={false}
            className="modal-frame-about"
            shouldCloseOnOverlayClick={true}
            onRequestClose={setAboutModalIsOpenToFalse}
            style={customStyles}
          >
            <div>
              <button
                className="modal-close"
                onClick={setAboutModalIsOpenToFalse}
                data-cy="modal-close-x-about"
                style={{ background: "#C4E7FF" }}
              >
                <img
                  src={XButton}
                  alt="close modal window"
                  className="modal-close-x"
                />
              </button>
            </div>
            <AboutModal closeCallBack={setAboutModalIsOpenToFalse} />
          </Modal>
        )}

        {/* help modal and sheet */}
        {props.isMobile && (
          <Sheet
            isOpen={helpModalDisplay}
            onClose={() => setHelpModalIsOpenToFalse}
            detent="content-height"
            disableDrag={true}
          >
            <Sheet.Container>
              <Sheet.Header>
                <div className="react-modal-sheet-header">
                  <div className="help-modal-header-text">
                    {t("help", { ns: COMMON_NAMESPACE })}
                  </div>
                  <button
                    className="modal-close"
                    onClick={setHelpModalIsOpenToFalse}
                    data-cy="modal-close-x-help"
                  >
                    <img
                      src={XButton}
                      alt="close modal window"
                      className="modal-close-x"
                    />
                  </button>
                </div>
              </Sheet.Header>
              <Sheet.Content>
                <HelpModal />
              </Sheet.Content>
            </Sheet.Container>
            {/* @ts-ignore */}
            <Sheet.Backdrop onClick={setHelpModalIsOpenToFalse} />
          </Sheet>
        )}
        {!props.isMobile && (
          // @ts-ignore
          <Modal
            isOpen={helpModalDisplay}
            ariaHideApp={false}
            className="modal-frame-help"
            shouldCloseOnOverlayClick={true}
            onRequestClose={setHelpModalIsOpenToFalse}
            style={customStyles}
          >
            <div className="modal-header">
              <div className="help-modal-header-text">
                {t("help", { ns: COMMON_NAMESPACE })}
              </div>
              <button
                className="modal-close"
                onClick={setHelpModalIsOpenToFalse}
                data-cy="modal-close-x-help"
              >
                <img
                  src={XButton}
                  alt="close modal window"
                  className="modal-close-x"
                />
              </button>
            </div>
            <HelpModal />
          </Modal>
        )}

        {/* privacy policy modal and sheet */}
        {props.isMobile && (
          <Sheet
            isOpen={privacyModalDisplay}
            onClose={() => setPrivacyModalIsOpenToFalse}
            disableDrag={true}
            detent="content-height"
          >
            <Sheet.Container>
              <Sheet.Header>
                <div className="react-modal-sheet-header">
                  <div className="help-modal-header-text">
                    {t("header", { ns: PRIVACY_MODAL_NAMESPACE })}
                  </div>
                  <button
                    className="modal-close"
                    onClick={setPrivacyModalIsOpenToFalse}
                    data-cy="modal-close-x-privacy"
                  >
                    <img
                      src={XButton}
                      alt="close modal window"
                      className="modal-close-x"
                    />
                  </button>
                </div>
              </Sheet.Header>
              <Sheet.Content>
                <PrivacyModal />
              </Sheet.Content>
            </Sheet.Container>
            {/* @ts-ignore */}
            <Sheet.Backdrop onClick={setPrivacyModalIsOpenToFalse} />
          </Sheet>
        )}
        {!props.isMobile && (
          // @ts-ignore
          <Modal
            isOpen={privacyModalDisplay}
            ariaHideApp={false}
            className="privacy-terms-modal-frame"
            shouldCloseOnOverlayClick={true}
            onRequestClose={setPrivacyModalIsOpenToFalse}
            style={customStyles}
          >
            <div className="modal-header">
              <div className="help-modal-header-text">
                {t("header", { ns: PRIVACY_MODAL_NAMESPACE })}
              </div>
              <button
                className="modal-close"
                onClick={setPrivacyModalIsOpenToFalse}
                data-cy="modal-close-x-privacy"
              >
                <img
                  src={XButton}
                  alt="close modal window"
                  className="modal-close-x"
                />
              </button>
            </div>
            <PrivacyModal />
          </Modal>
        )}

        {/* terms and conditions modal and sheet */}
        <TermsModal
          isOpen={termsModalDisplay}
          onClose={setTermsModalIsOpenToFalse}
          header="termsOfUse"
        />
      </StyledFooter>
      <Outlet context={session || payableSession} />
    </>
  );
};
